import React from "react";

export function Cloud({ className = "", style }) {
  return (
    <svg className={className} style={style} width="120" height="60" viewBox="0 0 120 60" fill="none" aria-hidden="true">
      <path d="M30 50c-13 0-23-8-23-19 0-10 8-17 18-17 3-9 12-14 22-14 12 0 22 8 24 19 10 1 17 7 17 16 0 9-8 15-19 15H30z" fill="#FFFFFF" opacity="0.9"/>
    </svg>
  );
}

export function Bow({ className = "", size = 40 }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <path d="M24 24c-6-8-20-10-20-2 0 7 12 9 20 2zM24 24c6-8 20-10 20-2 0 7-12 9-20 2z" fill="#F7C9DC" stroke="#2A1020" strokeWidth="2.2" strokeLinejoin="round"/>
      <path d="M24 24c-3 6-6 14-2 16 4-2 4-10 2-16zM24 24c3 6 6 14 2 16-4-2-4-10-2-16z" fill="#F7C9DC" stroke="#2A1020" strokeWidth="2.2" strokeLinejoin="round"/>
      <circle cx="24" cy="24" r="4.2" fill="#FBE08A" stroke="#2A1020" strokeWidth="2.2"/>
    </svg>
  );
}
